<template>
    <networks-provider v-slot="{
        campaign,
        proposal,
        contact,
        proposalStep,
        patchProposalStep,
        goNextStep,
        goPreviousStep,
        isLoading,
        isCompletingProposal,
        errors,
        forceReloadContact,
        forceReloadProposal,
        errorMessage,
    }" style="height: 100%">
        <proposal-networks-view
            :campaign="campaign"
            :proposal-step="proposalStep"
            :proposal="proposal"
            :contact="contact"
            :is-loading="isLoading"
            :is-completing-proposal="isCompletingProposal"
            :errors="errors"
            :error-message="errorMessage"
            @go-next-step="goNextStep"
            @go-previous-step="goPreviousStep"
            @patch-step="patchProposalStep"
            :force-reload-contact="forceReloadContact"
            :force-reload-proposal="forceReloadProposal"
        />
        </networks-provider>
</template>
<script>
    import ProposalNetworksView from "../data-views/proposals/ProposalNetworksView";
    import NetworksProvider from "../providers/proposal-steps/NetworksProvider";

    export default {
        name: "ProposalNetworksRouterView",
        components: {
            NetworksProvider,
            ProposalNetworksView,
        },
    }
</script>
